import { render, staticRenderFns } from "./MacrocategoryEditor.vue?vue&type=template&id=ec4a6fda"
import script from "./MacrocategoryEditor.vue?vue&type=script&lang=js"
export * from "./MacrocategoryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports